<template>
  <div class="Auftraege">

  <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">Stammdaten</li>
      </ol>
    </nav>
  </div>

    <b-table  :busy.sync="loading" striped hover :items="options" :fields="fields">
      <template #table-busy>
        <div class="text-center  my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Lädt...</strong>
        </div>
      </template>
    <template #cell(value)="data">
      <b-link :href="`#/stammdaten/${data.item.key}`">{{
      data.value }}</b-link>
    </template>
    <template #cell(id)="data">
      <b-link :href="`#/stammdaten/${data.item.key}`">{{
      data.value }}</b-link>
    </template>
    </b-table>

   <div v-if="showFunctions()">
   <hr/>
   <b-link class="btn btn-info" to="statusList" >Status List</b-link>
   </div>
   <div>Anzahl Cutter: {{ statistics.anzahlCutter }}, Erfahrung: Ø {{ statistics.avgErfahrungCutter }} Jahre</div>
  <div>Anzahl Mitglieder: {{ statistics.anzahlMitglieder }}, Erfahrung: Ø {{ statistics.avgErfahrungMitglieder }} Jahre</div>

<b-link  class="btn btn-info" :href="csvLink()">alle Aufträge herunterladen</b-link>
  </div>
</template>

<script>
import afunc from '@/functions'
import api from '@/api/generic'
export default {
  name: 'Stammdaten',
  data () {
    return {
      loading: false,
      statistics: {},
      fields: [{ key: 'value', label: 'Wählen Sie eine Tabelle zum bearbeiten' }],
      options: []
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    csvLink () {
      return '/api/ws/csvauftraege/' + this.$store.state.auth.token
    },
    async showFunctions () {
      return afunc.showInternalFunctions()
    },
    async refresh () {
      this.loading = true
      this.options = await api.overview()
      this.statistics = await api.statistics()
      this.loading = false
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Stammdaten.vue